import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

var whiteList = ['/login']

router.beforeEach(function(to, from, next) {
  NProgress.start()
  var hasToken = store.getters.token
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (!store.getters.routesGenerated) {
        // 路由未生成时，始终从后端刷新权限
        store.dispatch('user/getInfo').then(function(staff) {
          var perms = staff.permissions || []
          // 兼容 role 字符串与 roles 数组两种格式
          var role = staff.role || (Array.isArray(staff.roles) && staff.roles.length ? staff.roles[0] : '') || ''
          if (perms.length === 0) {
            if (role === 'super_admin') {
              perms = ['*']
            }
          }
          return store.dispatch('permission/generateRoutes', perms)
        }).then(function(routes) {
          router.addRoutes(routes)
          next(Object.assign({}, to, { replace: true }))
        }).catch(function() {
          store.dispatch('user/logout')
          next('/login?redirect=' + to.path)
          NProgress.done()
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login?redirect=' + to.path)
      NProgress.done()
    }
  }
})

router.afterEach(function() {
  NProgress.done()
})
